import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { eventOnce, initialSessionId } from '../lib/api'

/**
 * Terminal screen for a self-declared minor. Deliberately a dead end with no
 * way onward — the age answer is already recorded server-side and marks the
 * session ineligible, so there is nothing to continue to.
 */
export function ExitScreen() {
  const { t } = useTranslation()

  useEffect(() => {
    void eventOnce(initialSessionId, 'adult_ineligible', {}).catch(() => {})
  }, [])

  return (
    <div className="content-column text-center">
      <h1 className="value-title">{t('exit.title')}</h1>
      <p className="body-copy">{t('exit.body')}</p>
    </div>
  )
}
